import React from 'react';

const Loader = () => {
    return (
        <p className={"loader"}></p>
    );
};

export default Loader;